exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-upload {\r\n  display: flex;\r\n}\r\n.image-upload-url-div {\r\n  width: 100%;\r\n}\r\ndiv.image-upload-input-file-div .image-upload-url-input-file {\r\n  display: none;\r\n}\r\n.image-upload-icon {\r\n  padding-top: 33px;\r\n  padding-left: 5px;\r\n  font-size: 34px;\r\n  cursor: pointer;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/image-upload/styles.css
// module id = 2135
// module chunks = 29